import { Component} from "@angular/core";
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { filter } from "rxjs";
import { ConfirmationModalComponent } from "../shared/components/confirmation-modal/confirmation-modal.component";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [RouterOutlet, ConfirmationModalComponent],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.css",
})
export class AppComponent {
  showNavbar = true;
  constructor(private router: Router) {
    // Detect route changes
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // Hide navbar/footer for all routes starting with "/admin"
        this.showNavbar = !event.urlAfterRedirects.startsWith("/admin");
      });
  }

}
